export default "__VITE_ASSET__DvyQB0Iy__"